module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "/* float": "left",
      "*/margin": "0 auto",
      "text-align": "center",
      "display": "inline-block"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchword),
      expression: "searchword"
    }],
    staticClass: "form-control",
    staticStyle: {
      "display": "inline-block",
      "width": "80%"
    },
    attrs: {
      "placeholder": "Bitte Suchwort eingeben...",
      "type": "text",
      "id": "searchword"
    },
    domProps: {
      "value": (_vm.searchword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchword = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cba5b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/Dashboard/Searchfield.html
// module id = 565
// module chunks = 1